import type { UsageLimitMode } from '@/common/components/UsageLimitModal'

export interface DerivedLimitState {
  open: boolean
  mode: UsageLimitMode
  resetsAt?: string
  retryAfterSec?: number
  errorCode?: string
}

export function deriveLimitReachedState(
  error: (Error & {
    upgradeRequired?: boolean
    resetsAt?: string
    retryAfterSec?: number
    errorCode?: string
    status?: number
  }) | null | undefined,
  dismissed: boolean,
): DerivedLimitState {
  const upgradeRequired = !!error?.upgradeRequired
  const open = upgradeRequired && !dismissed
  // Key on status (not errorCode): supervisor 429 doesn't emit errorCode enum;
  // 402 only surfaces in edge cases (trial retired, free is permanent).
  const mode: UsageLimitMode = error?.status === 402 ? 'payment_required' : 'rate_limit'
  return {
    open,
    mode,
    resetsAt: error?.resetsAt,
    retryAfterSec: error?.retryAfterSec,
    errorCode: error?.errorCode,
  }
}
